export const NOTIFICATION_PERMISSION_DEFAULT = 'default'
export const NOTIFICATION_PERMISSION_GRANTED = 'granted'
export const NOTIFICATION_PERMISSION_DENIED = 'denied'
